import React, { useState, useEffect } from 'react';
import InputComponent from '../components/fields/InputComponent'
import CheckboxComponent from '../components/fields/CheckboxComponent'
import '../assests/scss/authorized.scss'
import { connect } from 'react-redux';

const AuthorizedContact  = React.memo((props) => {
   // console.log(props.labels,'page1')
   // console.log(props.getSessionStorage,'page1')
    return <>
        <div>
             <div className="innder-title-container">
                    <div className="innder-title">{props.labels['corporate.signup.page.title']}</div>
                 
                </div>
                <div className='auth-info'>{props.labels['corporate.signup.authorized.info']} </div>
        <div className='contact-form'>
            <div className='form-row-responsive'>
            <InputComponent label={props.labels['corporate.signup.label.firstName']} name="firstName" invalid={props.errorMsg.firstName ? 'invalid' : ''} onFocusInput ={props.onFocusInput} onBlurInput={props.onBlurInput}  focused={props.focused.firstName ? 'focused' : ''}    onChangeInput = {props.onChangeInput} value={props.inputs.firstName} error={props.labels['corporate.signup.error.msg.for.firstname']}  />

            <InputComponent label={props.labels['corporate.signup.label.lastName']}  name="lastName" invalid={props.errorMsg.lastName ? 'invalid' : ''}  onFocusInput ={props.onFocusInput} onBlurInput={props.onBlurInput}  focused={props.focused.lastName ? 'focused' : ''}   onChangeInput = {props.onChangeInput} value={props.inputs.lastName} error={props.labels['corporate.signup.error.msg.for.lastname']} />
            </div>

            <div className='form-row-responsive'>
            <InputComponent label={props.labels['corporate.signup.label.emailAddress']} name="email" invalid={props.errorMsg.email ? 'invalid' : ''} onFocusInput ={props.onFocusInput} onBlurInput={props.onBlurInput}  focused={props.focused.email ? 'focused' : ''}    onChangeInput = {props.onChangeInput} value={props.inputs.email} error={props.labels['corporate.signup.error.msg.for.email']}  />

            <InputComponent label={props.labels['corporate.signup.label.phone']}  name="phone" invalid={props.errorMsg.phone ? 'invalid' : ''}  onFocusInput ={props.onFocusInput} onBlurInput={props.onBlurInput}  focused='focused'   onChangeInput = {props.onChangeInput} value={props.inputs.phone} error={props.labels['corporate.signup.error.msg.for.phone']} />
            </div>
        </div>
        {/* <CheckboxComponent label={props.labels['corporate.signup.use.acc.inof']} id="use-my-ac-inof" onClickFunction = {props.useMyAccountInformation}  /> */}
        {/* <CheckboxComponent label={props.labels['corporate.signup.communication.info']} id="receive-market"/> */}
        </div>
        </>

});
const mapStateFromReducer = (state) => ({
    labels : state.corporateSignupReducer.labels || {},
    getSessionStorage : state.corporateSignupReducer.getSessionStorage || {}
})
export default connect(
    mapStateFromReducer,
    null
)(AuthorizedContact);

